<template>
    <div class="approveOpinions">
        <Timeline v-if="list.length">
            <TimelineItem
                v-for="item in list"
                :key="item._id"
                :class="`approveOpinions-${item.step_operate}`"
            >
                <Icon
                    slot="dot"
                    type="md-checkmark-circle"
                    size="22"
                    :class="`approveOpinions-${item.step_operate}-dot`"
                />

                <div class="approveOpinions-content">
                    <h3>{{ item.step_def.name }}</h3>
                    <p class="approveOpinions-content-info">
                        <span class="approveOpinions-content-info-box">
                            <img :src="$imageResize(item.user.avatarurl || $imageSrcMap.system.boy, {m: 'lfit',  w: 22, h: 22})">
                            <span class="username">{{ item.user.realname }}</span>
                            <span class="state">
                                {{ stepStatusMap[item.step_operate] ? stepStatusMap[item.step_operate].name : "未知操作" }}
                            </span>
                        </span>
                        <span class="time">
                            {{ item.operate_time | dateFormat("yyyy-MM-dd hh:mm:ss") }}
                        </span>
                    </p>
                    <p>
                        审批意见：{{ !item.step_opinion ? "暂无……" : item.step_opinion }}
                    </p>
                </div>
            </TimelineItem>
        </Timeline>

        <!-- 无记录 -->
        <p
            v-else
            class="approveOpinions-noData"
        >
            暂无审批记录……
        </p>
    </div>
</template>

<script>
    export default {
        name: "approveOpinions",
        props: {
            companyId: {
                type: String,
                required: true
            },
            appId: {
                type: String,
                required: true
            },
            approveData: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data () {
            return {
                list: [],
                stepStatusMap: this.$getAppModuleMap("Flow").statusNameMap
            };
        },
        computed: {
            flowInstId () {
                return this.approveData.flow_inst && this.approveData.flow_inst._id;
            }
        },
        created () {
            this.init();
        },
        methods: {
            init () {
                this.getOpinionList();
            },

            // 接口 -获取审批意见
            getOpinionList () {
                return this.$https({
                    url: {
                        module: "flowInst",
                        name: "opinionList"
                    },
                    params: {
                        flow_inst: this.flowInstId
                    },
                    callback: data => {
                        this.list = data.list;
                    }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/flow/approve/approveModal/approveOpinions.vue